<template>
  <div class="pagination">
    <div class="pagination__offset">
      {{ number(offsetStart) }} - {{ number(offsetEnd) }} sur {{ number(nbItems) }}
    </div>
    <div class="pagination__buttons pagination-buttons">
      <a
        class="btn pagination-buttons__previous"
        :class="{ disabled: !hasPreviousPage }"
        @click="goPreviousPage"
      >{{ trans('global.pagination.previous') }}</a>

      <a
        class="btn pagination-buttons__next"
        :class="{ disabled: !hasNextPage }"
        @click="goNextPage"
      >{{ trans('global.pagination.next') }}</a>
    </div>
  </div>
</template>

<script>
import translation from '@elements/translation';
import { number } from '@elements/number-formatter';

export default {
  mixins: [ translation ],
  props: {
    offsetStart: { type: Number, default: 0 },
    offsetEnd: { type: Number, default: 0 },
    nbItems: { type: Number, default: 0 },
    page: { type: Number, default: 0 },
    nbPages: { type: Number, default: 0 },
  },
  computed: {
    hasPreviousPage() {
      return this.page - 1 > 0;
    },
    hasNextPage() {
      return this.page + 1 <= this.nbPages;
    },
  },
  methods: {
    number,
    goNextPage() {
      this.$emit('go-page', this.page + 1);
    },
    goPreviousPage() {
      this.$emit('go-page', this.page - 1);
    },
  },
};
</script>

<style>
</style>
